import { Button, Form, Radio, Row, Spin, notification } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { ThirdPartyResponse, updateThirdParty } from 'services/thirdParty';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { useNavigate, useParams } from 'react-router-dom';

import Address from 'components/theme_components/ThirdParty/address/Address';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import ButtonLink from 'components/theme_components/ButtonLink';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import HeroTitle from 'components/theme_components/HeroTitle';
import Notifications from 'components/theme_components/Notifications';
import ParListSelect from 'components/ParListSelect';
import TitlePage from 'components/theme_components/Title';
import { getMyWizards } from 'services/workflow';
import { t } from 'i18next';
import { useGetThirdPartyDetail } from 'pages/ThirdParty/ThirdPartyDetail/useGetThirdPartyDetail';
import { useQuery } from 'react-query';

export type GeneralDataMoralTPProps = {
  onEdit?: () => void;
  isEditing?: boolean;
  isGrouping?: boolean;
};
//General data fot moral or super thirdparty
const TabCompany = ({
  onEdit = () => {},
  isEditing,
  isGrouping,
}: GeneralDataMoralTPProps) => {
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [RadioBTNvalue, setRadioBTNvalue] = useState<string>('');
  const [selectedChildAddress, setSelectedChildAddress] = useState<any>({});

  let { id, tptype } = useParams<{
    id: string;
    tptype: 'CONC' | 'PM' | 'SPM';
  }>();
  const navigate = useNavigate();

  const {
    data: thirdParty,
    refetch,
    isFetching,
  } = useGetThirdPartyDetail(isNaN(Number(id)) ? undefined : Number(id), 'TP');

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  console.log({ thirdParty }, 'Form', form.getFieldsValue());

  useEffect(() => {
    if (thirdParty) {
      // thirdParty.companyHierarchyTree

      form.setFieldsValue({
        tpclass: thirdParty?.generalData?.tpclass,
        tpclasslabel: thirdParty?.generalData?.tpclasslabel,
        tpclassdate: thirdParty?.generalData?.tpclassdate,
        tprevenue: thirdParty?.generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          thirdParty?.generalData?.tprevenuereferenceyear
        ),
        tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
        tpidentitycardexpirationdate: toDatePickerDate(
          thirdParty?.generalData?.tpidentitycardexpirationdate
        ),
        tpactivitysector: thirdParty?.generalData?.tpactivitysector,
        tpflagresident: thirdParty?.generalData?.tpflagresident,
        tpcategory: thirdParty?.generalData?.tpcategory,
        tpcompanysize: thirdParty?.generalData?.tpcompanysize,
        tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
        tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
        tpfree1: thirdParty?.additionalInfo?.tpfree1,
        tpfree2: thirdParty?.additionalInfo?.tpfree2,
        tpfree3: thirdParty?.additionalInfo?.tpfree3,
        tpfree4: thirdParty?.additionalInfo?.tpfree4,
        tpfree5: thirdParty?.additionalInfo?.tpfree5,
        tpdescription: thirdParty?.additionalInfo?.tpdescription,
        tpid: thirdParty?.generalData?.tpid,
        currcode: thirdParty?.generalData?.currcode,
        tpreference: thirdParty?.generalData?.tpreference,
        tptype: thirdParty?.generalData?.tptype,
        tptypelabel: thirdParty?.generalData?.tptypelabel,

        tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
        tpkycstatus: thirdParty?.generalData?.tpkycstatus,
        tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
        tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
        tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
        tpstatuslabelgeneraldata:
          thirdParty?.generalData?.tpstatuslabel +
          ' (' +
          thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
          ')',
        tpbrokerid: thirdParty?.generalData?.tpbrokerid,
        tplegalform: thirdParty?.generalData?.tplegalform,
        tpname: thirdParty?.generalData?.tpname,
        tpsurname: thirdParty?.generalData?.tpsurname,
        tpmiddlename: thirdParty?.generalData?.tpmiddlename,
        tpmaidenname: thirdParty?.generalData?.tpmaidenname,
        tpmarketingname: thirdParty?.generalData?.tpmarketingname,
        tpmanagername: thirdParty?.generalData?.tpmanagername,
        tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
        tpactivity: thirdParty?.generalData?.tpactivity,
        tpbranchid: thirdParty?.generalData?.tpbranchid,
        mgid: thirdParty?.generalData?.mgid,
        lancode: thirdParty?.generalData?.lancode,
        countcode: thirdParty?.generalData?.countcode,
        tpcompanycreationdate: toDatePickerDate(
          thirdParty?.generalData?.tpcompanycreationdate
        ),
        tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          thirdParty?.generalData?.tpvatexemtionenddate
        ),
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
        tptaxid: thirdParty?.generalData?.tptaxid,
        tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
        tpgender: thirdParty?.generalData?.tpgender,
        tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
        tpbirthcity: thirdParty?.generalData?.tpbirthcity,
        tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
        tpprofession: thirdParty?.generalData?.tpprofession,
        tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
        tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
        tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
        tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
        tpworkingctdate: toDatePickerDate(
          thirdParty?.generalData?.tpworkingctdate
        ),
        tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
        tporigin: thirdParty?.generalData?.tporigin,
        tpspecialtag: thirdParty?.generalData?.tpspecialtag,

        parentCompany: {
          tpid: thirdParty?.generalData?.tpparentcompanyid,
          tpname: thirdParty?.generalData?.tpparentcompanyidname,
          tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
        },
        tptradingid: thirdParty?.generalData?.tptradingid,
        tpcompanyid: thirdParty?.generalData?.tpcompanyid,

        tpparentcompanyidreference:
          thirdParty?.generalData?.tpparentcompanyidreference,
        tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
        tpcapital: thirdParty?.generalData?.tpcapital,
        tpbrand: thirdParty?.generalData?.tpbrand,
        tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
        tppoliticallyexposedperson:
          thirdParty?.generalData?.tppoliticallyexposedperson,
        tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
        tpAddressChilds: thirdParty?.address?.tpAddressChilds || [],
        tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
        tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
        tpmainadrstreet3: thirdParty?.address?.tpmainadrstreet3,
        tpmainadrcity: thirdParty?.address?.tpmainadrcity,
        tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
        tpmainadrregion: thirdParty?.address?.tpmainadrregion,
        tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
        tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
        tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
        tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
        tpsecadrcity: thirdParty?.address?.tpsecadrcity,
        tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
        tpsecadrregion: thirdParty?.address?.tpsecadrregion,
        tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
        bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
        bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
        bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
        bkcodemain: thirdParty?.bankAccount?.bkcode,
        bktypemain: thirdParty?.bankAccount?.bktype,
        tpibanmain: thirdParty?.bankAccount?.tpiban,
        tpbicmain: thirdParty?.bankAccount?.tpbic,
        tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
        tpcbtype: thirdParty?.bankAccount?.tpcbtype,
        tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
        tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
        tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
        tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
        tptel1: thirdParty?.contact?.tptel1,
        tptelmobile1: thirdParty?.contact?.tptelmobile1,
        tpemail1: thirdParty?.contact?.tpemail1,
        tpcontactname1: thirdParty?.contact?.tpcontactname1,
        tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
        tptel2: thirdParty?.contact?.tptel2,
        tptelmobile2: thirdParty?.contact?.tptelmobile2,
        tpemail2: thirdParty?.contact?.tpemail2,
        tpcontactname2: thirdParty?.contact?.tpcontactname2,
        tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
        tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
        tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
        tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
          0,
          10
        ),
        tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
        tpriskusername: thirdParty?.correspondent?.tpriskusername,
        tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
          0,
          10
        ),
        tpbouserid: thirdParty?.correspondent?.tpbouserid,
        tpbousername: thirdParty?.correspondent?.tpbousername,
        tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
        tprecuserid: thirdParty?.correspondent?.tprecuserid,
        tprecusername: thirdParty?.correspondent?.tprecusername,
        tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(
          0,
          10
        ),
        tplpuserid: thirdParty?.correspondent?.tplpuserid,
        tplpusername: thirdParty?.correspondent?.tplpusername,
        tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
        tpemployer: thirdParty?.income?.tpemployer,
        tpemployeraddress: thirdParty?.income?.tpemployeraddress,
        tpemloyertel: thirdParty?.income?.tpemloyertel,
        tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
        tpothersincome: thirdParty?.income?.tpothersincome,
        tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
        tpothersexpense: thirdParty.income?.tpothersexpense,
        tpotherloan: thirdParty?.income?.tpotherloan,
        tpflagclient: thirdParty?.role?.tpflagclient,
        tpflagsupplier: thirdParty?.role?.tpflagsupplier,
        tpflagguarantor: thirdParty?.role?.tpflagguarantor,
        tproleother: thirdParty?.role?.tproleother,
        tppaymodein: thirdParty?.role?.tppaymodein,
        tppaydelayin: thirdParty?.role?.tppaydelayin,
        tppaymodeout: thirdParty?.role?.tppaymodeout,
        tppaydelayout: thirdParty?.role?.tppaydelayout,
        tplateinterestformula: thirdParty?.role?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          thirdParty.role?.tpblocklateinterestinvoicing,
        tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          thirdParty?.role?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          thirdParty?.role?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

        spname: thirdParty?.spouse?.spname,
        spsurname: thirdParty?.spouse?.spsurname,
        spgender: thirdParty?.spouse?.spgender,
        spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
        spbirthcity: thirdParty?.spouse?.spbirthcity,
        spbirthcountry: thirdParty?.spouse?.spbirthcountry,
        spmaidenname: thirdParty?.spouse?.spmaidenname,

        spsalutationcode: thirdParty?.spouse?.spsalutationcode,
        spfiscalid: thirdParty?.spouse?.spfiscalid,
        spprofession: thirdParty?.spouse?.spprofession,
        spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
        spidentitycardid: thirdParty?.spouse?.spidentitycardid,
        spemployer: thirdParty?.spouse?.spemployer,
        spemployeraddress: thirdParty?.spouse?.spemployeraddress,
        spemloyertel: thirdParty?.spouse?.spemloyertel,
        spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
        spothersincome: thirdParty?.spouse?.spothersincome,
        spothersexpense: thirdParty?.spouse?.spothersexpense,
        spotherloan: thirdParty?.spouse?.spotherloan,
        tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
        tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(
          0,
          10
        ),
        tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
        tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(
          0,
          10
        ),
      });
    }
  }, [thirdParty, RadioBTNvalue]);

  const prepareThirdPartyRequest = (values: any): any => {
    // const tpChildList = [...tpList, ...tpList2].map((tp) => tp.tpid);
    return {
      additionalInfo: {
        tpparentcompanyid: null,
        tpparentcompanyname: values?.tpparentcompanyname,
        tpfree1: values?.tpfree1,
        tpfree2: values?.tpfree2,
        tpfree3: values?.tpfree3,
        tpfree4: values?.tpfree4,
        tpfree5: values?.tpfree5,
        tpdescription: values?.tpdescription,
      },
      address: {
        tpAddressChilds: values?.tpAddressChilds,
        tpmainadrstreet1: values?.tpmainadrstreet1 ||  selectedChildAddress.tpmainadrstreet1,
        tpmainadrstreet2: values?.tpmainadrstreet2 || selectedChildAddress.tpmainadrstreet2,
        tpmainadrstreet3: values?.tpmainadrstreet3 || selectedChildAddress.tpmainadrstreet3,
        tpmainadrcity: values?.tpmainadrcity || selectedChildAddress.tpmainadrcity,
        tpmainadrzipcode: values?.tpmainadrzipcode || selectedChildAddress.tpmainadrzipcode,
        tpmainadrregion: values?.tpmainadrregion || selectedChildAddress.tpmainadrregion,
        tpmainadrregionglobale: values?.tpmainadrregionglobale || selectedChildAddress.tpmainadrregionglobale,
        tpmainadrcountry: values?.tpmainadrcountry || selectedChildAddress.tpmainadrcountry,
        tpsecadrstreet1: values?.tpsecadrstreet1,
        tpsecadrstreet2: values?.tpsecadrstreet2,
        tpsecadrcity: values?.tpsecadrcity,
        tpsecadrzipcode: values?.tpsecadrzipcode,
        tpsecadrregion: values?.tpsecadrregion,
        tpsecadrcountry: values?.tpsecadrcountry,
      },
      bankAccount: {
        bkaccountkey: values?.bkaccountkeymain,
        bkaccountnum: values?.bkaccountnummain,
        bkbranchcode: values?.bkbranchcodemain,
        bkcode: values?.bkcodemain
          ? values?.bkcodemain
          : form.getFieldValue('bkcodemain'),
        bktype: values?.bktype,
        countcode: values?.countcode,
        tpbkid: values?.tpbkid,
        currcode: values?.currcode,
        tpiban: values?.tpibanmain,
        tpbic: values?.tpbicmain,
        tpbankname: values?.tpbanknamemain,
        tpcbtype: values?.tpcbtype,
        tpcbnum: values?.tpcbnum,
        tpcbdate: values?.tpcbdate,
        tpcbkey: values?.tpcbkey,
        tpcbname: values?.tpcbname,
      },
      contact: {
        tptelmobile1: values?.tptelmobile1,
        tpemail1: values?.tpemail1,
        tpcontactname1: values?.tpcontactname1,
        tpcontactposition1: values?.tpcontactposition1,
        tptel2: values?.tptel2,
        tptelmobile2: values?.tptelmobile2,
        tpemail2: values?.tpemail2,
        tpcontactname2: values?.tpcontactname2,
        tpcontactposition2: values?.tpcontactposition2,
        tpcontactid: 0,
        tpid: 0,
        firstname: '',
        lastname: '',
        position: '',
        tel1: '',
        tel2: '',
        email: '',
      },
      generalData: {
        tpcompanyid: values?.tpcompanyid,
        tptradingid: values?.tptradingid,
        currcode: values?.currcode,
        tpid: Number(id),
        tptype: 'PM',
        tpbrokerid: values?.tpbrokerid,
        tplegalform: values?.tplegalform,
        tpname: values?.tpname,
        tpsurname: values?.tpsurname,
        tpmiddlename: values?.tpmiddlename,
        tpmaidenname: values?.tpmaidenname,
        tpflagvatexemption: values?.tpflagvatexemption,
        tpvatexemtionenddate: values?.tpvatexemtionenddate,
        tpmarketingname: values?.tpmarketingname,
        tpmanagername: values?.tpmanagername,
        tpmanagerposition: values?.tpmanagerposition,
        tpactivity: values?.tpactivity,
        tpbranchid: values?.tpbranchid,
        tpbrand: values?.tpbrand,
        lancode: values?.lancode,
        countcode: values?.countcode,
        tpcompanycreationdate: values?.tpcompanycreationdate,
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: values?.tpfiscalcity,
        tptaxid: values?.tptaxid,
        tpsalutationcode: values?.tpsalutationcode,
        tpgender: values?.tpgender,
        tpbirthdate: values?.tpbirthdate,
        tpbirthcity: values?.tpbirthcity,
        tpbirthcountry: values?.tpbirthcountry,
        tpprofession: values?.tpprofession,
        tpidentitycardtype: values?.tpidentitycardtype,
        tpidentitycardid: values?.tpidentitycardid,
        tpmaritalstatus: values?.tpmaritalstatus,
        tppaymentdelegation: values?.tppayementdelegation,
        tpnbofchildren: values?.tpnbofchildren,
        tpworkingctdate: dateToString(values?.tpworkingctdate),
        tpworkingcttype: values?.tpworkingcttype,
        tpcapital: values?.tpcapital,
        tpcapitalholding: values?.tpcapitalholding,
        tpkycstatus: values?.tpkycstatus,
        tppoliticallyexposedperson: values?.tppoliticallyexposedperson,
        tpantimoneylaunder: values?.tpantimoneylaunder,
        tporigin: values?.tporigin,
        tpspecialtag: values?.tpspecialtag,
        tpparentcompanyid: null,
        last_action: wizData?.taskidCreate,
        tpflagresident: values?.tpflagresident,
        tpcategory: values?.tpcategory,
        tpcompanysize: values?.tpcompanysize,
        tprevenue: values?.tprevenue,
        tprevenuereferenceyear: values?.tprevenuereferenceyear,
        tpidentitycardcountry: values?.tpidentitycardcountry,
        tpidentitycardexpirationdate: dateToString(
          values?.tpidentitycardexpirationdate
        ),
        tpactivitysector: values?.tpactivitysector,
        tpreference: values?.tpreference,
      },
      income: {
        tpemployer: values?.tpemployer,
        tpemployeraddress: values?.tpemployeraddress,
        tpemloyertel: values?.tpemloyertel,
        tpmonthlyincome: values?.tpmonthlyincome,
        tpothersincome: values?.tpothersincome,
        tpfamilybenefits: values?.tpfamilybenefits,
        tpothersexpense: values?.tpothersexpense,
        tpotherloan: values?.tpotherloan,
      },
      role: {
        tpreminderfeesformula: values?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          values?.tpblockreminderfeesinvoicing === undefined
            ? false
            : values?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          values?.tpblockrejectionfeesinvoicing === undefined
            ? false
            : values?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: values?.tprejectionfeesformula,

        tpflagclient: true,
        tpflagsupplier: true,
        tpflagguarantor: values?.tpflagguarantor,
        tproleother: values?.tproleother,
        tppaymodein: values?.tppaymodein,
        tppaydelayin: values?.tppaydelayin,
        tppaymodeout: values?.tppaymodeout,
        tppaydelayout: values?.tppaydelayout,
        tplateinterestformula: values?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          values?.tpblocklateinterestinvoicing === undefined
            ? false
            : values?.tpblocklateinterestinvoicing,
      },
      spouse: {
        spname: values?.spname,
        spsurname: values?.spsurname,
        spgender: values?.spgender,
        spbirthdate: dateToString(values?.spbirthdate),
        spbirthcity: values?.spbirthcity,
        spbirthcountry: values?.spbirthcountry,
        spmaidenname: values?.spmaidenname,
        spsalutationcode: values?.spsalutationcode,
        spfiscalid: values?.spfiscalid,
        spprofession: values?.spprofession,
        spidentitycardtype: values?.spidentitycardtype,
        spidentitycardid: values?.spidentitycardid,
        spemployer: values?.spemployer,
        spemployeraddress: values?.spemployeraddress,
        spemloyertel: values?.spemloyertel,
        spmonthlyincome: values?.spmonthlyincome,
        spothersincome: values?.spothersincome,
        spothersexpense: values?.spothersexpense,
        spotherloan: values?.spotherloan,
      },
    };
  };

  const [tpList, setTpList] = useState<ThirdPartyResponse[]>([]);
  const [tpList2, setTpList2] = useState<ThirdPartyResponse[]>([]);

  const onFinish = (e: any) => {
    let tpListId = tpList?.map((tp: any) => tp.tpid);
    let tpListId2 = tpList2?.map((tp: any) => tp.tpid);

    const tpdData = prepareThirdPartyRequest(e);

    form
      .validateFields(e)
      .then((values) => {
        const tpdData = prepareThirdPartyRequest(values);

        console.log('this is tpdata=>', tpdData);

        let generalData = {
          ...tpdData?.generalData,
          tpbirthdate: dateToString(tpdData?.generalData?.tpbirthdate),
        };

        const dataSave = {
          ...tpdData,
          generalData: generalData,
          tpChild: [...tpListId, ...tpListId2],
        };
        if (isGrouping) {
          setIsLoading(true);
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(id),
          })
            .then((res) => {
              setIsLoading(false);

              if (res.code === '200') {
                Notifications({
                  status: 'success',
                  message: 'Modifications effectuées',
                  description:
                    'Les informations du tiers moral peuvent être modifié dans sa fiche',
                  duration: 3,
                  placement: 'top',
                });
                const lastItem =
                  res.data.tpChildrenList[res.data.tpChildrenList.length - 1];
                navigate(`/thirdparty-sfs/${lastItem.tpid}/CONC`);
              } else {
                Notifications({
                  status: 'error',
                  message: 'Erreur',
                  description: res.description,
                  duration: 30,
                  placement: 'top',
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
            });
        } else {
          setIsLoading(true);
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(id),
          })
            .then((res) => {
              setIsLoading(false);

              if (res.code === '200') {
                Notifications({
                  status: 'success',
                  message: 'Le tiers a été modifié.',
                  description: res.description,
                  duration: 5,
                  placement: 'topRight',
                });
                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/PM`);

                // if (onEdit) onEdit(); // Trigger the onEdit callback if defined
                // refetch(); // Refetch data to refresh the state
              } else {
                notification.error({
                  message: 'Error',
                  description: res.message || 'An error occurred',
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);

              notification.error({
                message: 'Error',
                description: err.message || 'An error occurred while updating',
              });
            });
        }
        //.finally(() => setLoading(false));
      })
      .catch((err) => {
        // setLoading(false);
        notification.error({
          message: 'Validation Error',
          description: 'Please check the required fields and try again.',
        });
      });
  };
  console.log({ isGrouping });
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => {
        onFinish(values);
      }}
    >
      <TitlePage
        level={2}
        comcode={isGrouping ? 'groupingTPM' : 'updatemoraltp'}
        bgColor="duck-blue"
      />
      <Spin spinning={isFetching}>
        <div className="container-stepper mt-10">
          {isGrouping ? (
            <div className="no-border-radius ut-wizard-form ">
              <Row gutter={16}>
                <GetLabel label="info" className="mb-8 font-size-18" />
                <FormInput
                  col
                  xs={24}
                  md={24}
                  name="tpname"
                  rules={[{ required: true }]}
                />
                <FormInput
                  name="flagaddresse"
                  className="form-item no-border-radius radio-btn-PM"
                  nolabel
                >
                  <Radio.Group
                    onChange={(e: any) => {
                      setRadioBTNvalue(e.target.value);
                      console.log({ e });
                    }}
                    defaultValue={'select'}
                  >
                    <Radio value="select">
                      {' '}
                      <GetLabel label="Addresse d’un tiers physique" />{' '}
                    </Radio>
                    <Radio value="add">
                      {' '}
                      <GetLabel label="Addresse manuelle" />{' '}
                    </Radio>
                  </Radio.Group>
                </FormInput>
                {RadioBTNvalue === 'select' ? (
                  <FormInput
                    col
                    xs={24}
                    name="addresse"
                    className="form-item no-border-radius"
                  >
                    <AddresseListSelect
                      params={{ tpid: form.getFieldValue('tpid') }}
                      className="no-border-radius"
                    />
                  </FormInput>
                ) : (
                  <>
                    <FormInput
                      col
                      xs={24}
                      md={24}
                      name="tpmainadrstreet1"
                      rules={[{ required: true }]}
                    />
                    <FormInput col xs={24} md={24} name="tpmainadrstreet2" />
                    <FormInput col xs={24} md={24} name="tpmainadrstreet3" />
                    <AddressSFS
                      form={form}
                      codePostalField="tpmainadrzipcode"
                      paysField="tpmainadrcountry"
                      regionField="tpmainadrregion"
                      villeField="tpmainadrcity"
                      colU={24}
                      countryRequired
                      zipcodeRequired
                      cityRequired
                      hideRegionGlobal
                      hideRegion
                      Colw={
                        localStorage.getItem('lancode') === 'FR'
                          ? { span: 6 }
                          : { span: 6 }
                      }
                      spanCountry={7}
                      spanZip={7}
                      spanCity={16}
                    />
                  </>
                )}
              </Row>
              <Row justify="end">
                <ButtonLink
                  type="primary"
                  comcode="Valider"
                  htmlType="submit"
                  onClick={(values: any) => {
                    onFinish(values);
                  }}
                  // icon={<RightOutlined />}
                  loading={isLoading}
                />
              </Row>
            </div>
          ) : (
            <div className="no-border-radius ut-wizard-form mt-8">
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={24}
                  name="tpname"
                  rules={[{ required: true }]}
                />
                <FormInput
                  name="flagaddresse"
                  className="form-item no-border-radius radio-btn-PM"
                  nolabel
                >
                  <Radio.Group
                    onChange={(e: any) => {
                      setRadioBTNvalue(e.target.value);
                      console.log({ e });
                    }}
                    defaultValue={'add'}
                  >
                    <Radio value="select">
                      {' '}
                      <GetLabel label="Addresse d’un tiers physique" />{' '}
                    </Radio>
                    <Radio value="add">
                      {' '}
                      <GetLabel label="Addresse manuelle" />{' '}
                    </Radio>
                  </Radio.Group>
                </FormInput>
                {RadioBTNvalue === 'select' ? (
                  <FormInput
                    col
                    xs={24}
                    name="addresse"
                    className="form-item no-border-radius"
                  >
                    <AddresseListSelect
                      data={thirdParty?.address?.tpAddressChilds}
                      className="no-border-radius"
                      onUpdateParentAddress={(selectedChildAddress) => {
                        console.log(
                          'Updating parent address with:',
                          selectedChildAddress
                        );
                        setSelectedChildAddress(selectedChildAddress);
                      }}
                    />
                  </FormInput>
                ) : (
                  <>
                    <FormInput
                      col
                      xs={24}
                      md={24}
                      name="tpmainadrstreet1"
                      rules={[{ required: true }]}
                    />
                    <FormInput col xs={24} md={24} name="tpmainadrstreet2" />
                    <FormInput col xs={24} md={24} name="tpmainadrstreet3" />
                    <AddressSFS
                      form={form}
                      codePostalField="tpmainadrzipcode"
                      paysField="tpmainadrcountry"
                      regionField="tpmainadrregion"
                      villeField="tpmainadrcity"
                      colU={24}
                      countryRequired
                      zipcodeRequired
                      cityRequired
                      hideRegionGlobal
                      hideRegion
                      Colw={
                        localStorage.getItem('lancode') === 'FR'
                          ? { span: 6 }
                          : { span: 6 }
                      }
                      spanCountry={7}
                      spanZip={7}
                      spanCity={16}
                    />
                  </>
                )}
              </Row>
              <Row justify="end">
                <ButtonLink
                  comcode="Annuler"
                  type="text"
                  onClick={() => {
                    form.resetFields();
                    navigate(-1);
                  }}
                  // icon={<LeftOutlined />}
                  className="ut-btn-bordred ut-custom-prev mr-2"
                />
                <ButtonLink
                  type="primary"
                  comcode="Valider"
                  className="ml-1"
                  htmlType="submit"
                  onClick={(values: any) => {
                    onFinish(values);
                  }}
                  // icon={<RightOutlined />}
                  loading={isLoading}
                />
              </Row>
            </div>
          )}
        </div>
      </Spin>
    </Form>
  );
};

export default TabCompany;
